import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Container } from '@material-ui/core'
import { useTracking } from 'lib/babylistHealthAnalytics'
import { UI } from '../../../global'
import { PHYSICIAN_RESULT_PATH } from '../../constants'
import { useDMEStore } from '../../store'
import PhysicianSearchView from '../PhysicianSearchView'
import PhysicianSelectorWidget from './PhysicianSelectorWidget/PhysicianSelectorWidget'
import { physicianResultViewedEvent } from '../../events'
import useStyles from './styles'
import CheckoutJourneyStepsWidget from '../../widgets/CheckoutJourneyStepsWidget'
import CheckoutJourneyWrapperWidget from '../../widgets/CheckoutJourneyWrapperWidget'

const PhysicianResultView: UI.ViewComponent = observer(({ router }) => {
  const store = useDMEStore()

  if (!store.physician.all) {
    PhysicianSearchView.location!(router)
    return null
  }

  const tracker = useTracking()

  useEffect(() => {
    physicianResultViewedEvent(tracker)()
  }, [])

  const classes = useStyles()

  return (
    <Container className={classes.viewContainer}>
      <CheckoutJourneyWrapperWidget>
        <CheckoutJourneyStepsWidget
          currentPath={`/${PHYSICIAN_RESULT_PATH.split('/').pop()}`}
        />
        <PhysicianSelectorWidget goToPreviousPage={router.goBack} />
      </CheckoutJourneyWrapperWidget>
    </Container>
  )
})

PhysicianResultView.location = (router) => {
  if (router) {
    router.push(PHYSICIAN_RESULT_PATH)
  } else {
    window.location.href = PHYSICIAN_RESULT_PATH
  }
}

export default PhysicianResultView
